module.exports = __webpack_public_path__ + "fonts/fa-brands-400.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fa-brands-400.woff2
// module id = 45
// module chunks = 0